import React from 'react'
import PropTypes from 'prop-types'
import css from './RAFTitle.css'

const RAFTitle = ({title}) => (
  <div className={css.rafTitle}>
    <h1 className={css.title}>{title}</h1>
  </div>
)

RAFTitle.propTypes = {
  title: PropTypes.string,
}

RAFTitle.defaultProps = {
  title: '',
}

export { RAFTitle }
